import { TBaseBannerProps } from './BaseBanner.types';
import React from 'react';
import s from './BaseBanner.module.scss';
import { BaseIcon } from 'src/components/BaseIcon';
import { BaseButton } from 'src/components/BaseButton';

export const BaseBanner: React.FC<TBaseBannerProps> = ({
  cta,
  iconStart,
  textHeading: heading,
  text,
}) => {
  return (
    <div className={s.baseBanner}>
      {iconStart && (
        <div className={s.iconWrapper}>
          <BaseIcon icon={iconStart} size={15} />
        </div>
      )}
      <div className={s.text}>
        <p className={s.bannerHeading}>{heading}</p>
        <p>{text}</p>
      </div>
      {cta && (
        <div className={s.bannerCTA}>
          <BaseButton size="normal" onClick={cta.handler}>
            {cta.label}
          </BaseButton>
        </div>
      )}
    </div>
  );
};
